import React from 'react';
import { FieldWrapper } from '@td-client-frontend/common';
import ComponentWrapperRHF from './ComponentWrapperRHF';

interface Props {
  name: string;
  label?: string;
  rows?: number;
  maxLength?: number;
  required?: boolean;
}

export const TextAreaRHF = ({ ...props }: Props) => {
  return (
    // @ts-ignore
    <ComponentWrapperRHF {...props}>
      <TextArea />
    </ComponentWrapperRHF>
  );
};

const TextArea = ({ isError, error, label, ...props }) => {
  return (
    <FieldWrapper label={label} isError={isError} error={error}>
      <textarea {...props} />
    </FieldWrapper>
  );
};
